export const getCarouselResponsiveElements = (breakpoints: string[]) => [
  {
    // some arbitarily large number, bigger than any reasonable screen size.
    breakpoint: 40000,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
    },
  },
  {
    breakpoint: 1600,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
    },
  },
  {
    breakpoint: Number(breakpoints[2].replace('px', '')),
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
    },
  },
  {
    breakpoint: Number(breakpoints[1].replace('px', '')),
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
    },
  },
  {
    breakpoint: Number(breakpoints[0].replace('px', '')),
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: true,
    },
  },
  {
    breakpoint: 320,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
    },
  },
]
